import '../style/image-B3LUnNA9.css'
import { defineComponent as k, useCssVars as b, toRef as R, computed as a, openBlock as s, createElementBlock as j, unref as o, createBlock as v, createCommentVNode as B, createElementVNode as F, normalizeStyle as S } from "vue";
import h from "./skeleton.js";
import { useImageLazy as C } from "./hooks/useImageLazy.js";
const L = ["data-src", "alt"], E = /* @__PURE__ */ k({
  name: "e-image",
  __name: "image",
  props: {
    src: { default: "" },
    delay: { default: 0 },
    skeleton: {},
    ratio: {},
    alt: {},
    objectFit: {}
  },
  emits: ["load"],
  setup(l, { emit: n }) {
    b((t) => ({
      ce3432a6: g.value
    }));
    const e = l, c = n, m = R(e, "src"), { loaded: d, imgRef: f, rootRef: u, handleLoad: r } = C({
      dataSrc: m,
      delay: e.delay,
      emit: c
    }), p = a(() => e.alt ?? e.src.split("/").slice(-1).toString()), g = a(() => e.ratio ? `${1 / e.ratio * 100}%` : null), _ = a(() => {
      const t = {};
      return e.ratio && (t.position = "absolute", t.top = 0, t.height = "100%"), e.objectFit && (t.objectFit = e.objectFit), t;
    });
    return (t, i) => (s(), j("div", {
      ref_key: "rootRef",
      ref: u,
      class: "e-image"
    }, [
      o(d) ? B("", !0) : (s(), v(o(h), {
        key: 0,
        class: "e-image__skeleton",
        icon: { icon: "image-fill" }
      })),
      F("img", {
        ref_key: "imgRef",
        ref: f,
        "data-src": t.src,
        alt: p.value,
        style: S(_.value),
        onLoad: i[0] || (i[0] = //@ts-ignore
        (...y) => o(r) && o(r)(...y))
      }, null, 44, L)
    ], 512));
  }
});
export {
  E as default
};
//# sourceMappingURL=image.js.map
